// extracted by mini-css-extract-plugin
module.exports = {"synced":"SyncStatus_synced__2OZsA","failed":"SyncStatus_failed__2NoSm","skipped":"SyncStatus_skipped__3Sn1a","awaiting":"SyncStatus_awaiting__3he0r"};